import { Injectable, forwardRef, Inject } from '@angular/core';
import { ReportApiHandlerService } from '../api-handler/api-handler.service';
import { environment } from '../../../../environments/environment';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { CommonDispatcher } from '../../../store/common/common-dispatcher';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { SpinnerService } from '../../../common/components/spinner/overlay-spinner.service';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import {
  FormAttributes,
  ApiRequestParams,
} from '../../report-form/report.interface';
import { format } from 'url';
import { sxmReports, tciReports, telematicsReports } from '../../report-form/report.details';

@Injectable()
export class OrchestrationService {
  /**
   *@var Declaration of spinner Ref
   **/
  public spinnerRef;
  private setTciReport = 'setTciReport';
  private setSxmReport = 'setSxmReport';
  private setTelematicsReport = 'setTelematicsReport';
  /**
   * @var This property will set the value of report when exist in the header
   **/
  private defaultReportValue = 'Y';

  constructor(
    @Inject(forwardRef(() => ReportApiHandlerService))
    public apiHandler: ReportApiHandlerService,
    public apiDispatcher: ApiResponseDispatcher,
    public commonDispatcher: CommonDispatcher,
    public customerDispatcher: CustomerDispatcher,
    public dialog: MatDialog,
    public router: Router,
    public spinner: SpinnerService,
    private snackBarService: SnackBarService,
    private translate: TranslationService,
    public ngRedux: NgRedux<AppState>
  ) { }
  /**
   * set the api response error or success
   **/
  private setResponse(method: string, type: string, body: object) {
    this.spinnerRef.close();
    this.apiDispatcher[method](Object.assign(body, { type }));
  }
  /**
   * formatDate helper function to format the date to yyyyMMddHHmmss
   **/
  formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const mm =
      date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const min =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const ss =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return [yyyy, mm, dd, hh, min, ss].map((x) => x.toString()).join('');
  }
  /**
   * getReport contains swtich to select right report from formAttriutes.
   **/
  getReport(formAttributes: FormAttributes): void {
    const data: ApiRequestParams = this.getApiRequestParams(formAttributes);
    switch (formAttributes.reportName) {
      case tciReports.reportOn:
        this.callReportApi(
          environment.reports.apis.tci,
          this.setTciReport,
          data
        );
        break;
      case sxmReports.reportOn:
        this.callReportApi(
          environment.reports.apis.sxm,
          this.setSxmReport,
          data
        );
        break;
      case telematicsReports.reportOn:
        this.callReportApi(
          environment.reports.apis.telematics,
          this.setTelematicsReport,
          data
        );
        break;
    }
  }

  /**
   * getApiRequestParams Calls to get api params out of form attributes
   **/
  getApiRequestParams(form_attrs: FormAttributes): ApiRequestParams {
    return {
      type: form_attrs.reportName,
      params: {
        reports: form_attrs.reports.map((reportName) => {
          return { name: reportName, value: this.defaultReportValue };
        }),
        start_date: {
          name: form_attrs.startDateKey,
          value: form_attrs.startDateValue && this.formatDate(form_attrs.startDateValue),
        },
        end_date: {
          name: form_attrs.endDateKey,
          value: form_attrs.endDateValue && this.formatDate(form_attrs.endDateValue),
        },
      },
    };
  }

  /**
   * callReportApi Calls API for report generation
   **/
  public callReportApi(url: string, dispatcher: string, body: ApiRequestParams) {
    this.spinnerRef = this.spinner.open();
    this.apiDispatcher[dispatcher]({});
    this.apiHandler.getRequest(url, body).subscribe({
      next: (response) => this.setResponse(dispatcher, 'success', response),
      error: (error) => this.setResponse(dispatcher, 'error', error)
    }
    );
  }
}
